export function getView(profile_url) {
  return profile_url ? 'Picture' : 'Initials'
}
